import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const hasAuthenticity = localStorage.getItem('auth');

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    hasAuthenticity 
    ? <Component {...props} /> 
    : window.open("/","_self")
  )} />
);
